import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { PlayerBar } from "./PlayerBar";
import { TrackModal } from "./TrackModal";

export const Layout = ({ children }) => (
  <div className="min-h-screen bg-navy-950 text-slate-200 font-sans">
    <Navbar />
    <main>{children}</main>
    <Footer />
    <PlayerBar />
    <TrackModal />
  </div>
);
